export const PWA_UPDATE_EVENT = "clinicalos:pwa-update";

export function isStandaloneMode() {
  const navigatorWithStandalone = navigator as Navigator & { standalone?: boolean };
  return (
    window.matchMedia?.("(display-mode: standalone)").matches === true ||
    navigatorWithStandalone.standalone === true
  );
}

export function isIosDevice() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

export async function registerClinicalOsServiceWorker() {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return null;

  const registration = await navigator.serviceWorker.register("/service-worker.js", {
    scope: "/",
  });

  const notifyUpdate = () => window.dispatchEvent(new Event(PWA_UPDATE_EVENT));

  if (registration.waiting && navigator.serviceWorker.controller) notifyUpdate();

  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    if (!worker) return;

    worker.addEventListener("statechange", () => {
      if (worker.state === "installed" && navigator.serviceWorker.controller) {
        notifyUpdate();
      }
    });
  });

  return registration;
}

export async function activateWaitingServiceWorker() {
  const registration = await navigator.serviceWorker.getRegistration("/");
  if (!registration?.waiting) {
    window.location.reload();
    return;
  }

  const reload = () => window.location.reload();
  navigator.serviceWorker.addEventListener("controllerchange", reload, { once: true });
  registration.waiting.postMessage({ type: "SKIP_WAITING" });
}
